/**
 * Exception classes for the Swimmable JavaScript SDK
 */

/**
 * Base exception class for all Swimmable SDK errors
 */
export class SwimmableError extends Error {
  public status?: number;
  public code?: string;
  public endpoint?: string;

  constructor(message: string, status?: number, code?: string, endpoint?: string) {
    super(message);
    this.name = 'SwimmableError';
    this.status = status;
    this.code = code;
    this.endpoint = endpoint;
  }
}

/**
 * Exception raised for API-related errors (4xx, 5xx responses)
 */
export class SwimmableAPIError extends SwimmableError {
  public responseData?: any;

  constructor(
    message: string, 
    status: number,
    code?: string,
    endpoint?: string,
    responseData?: any
  ) {
    super(message, status, code, endpoint);
    this.name = 'SwimmableAPIError';
    this.responseData = responseData;
  }
}

/**
 * Exception raised when a request times out
 */
export class SwimmableTimeoutError extends SwimmableError {
  public timeout?: number;

  constructor(message: string = 'Request timed out', timeout?: number) {
    super(message);
    this.name = 'SwimmableTimeoutError';
    this.timeout = timeout;
  }
}

/**
 * Exception raised for client-side validation errors
 */
export class SwimmableValidationError extends SwimmableError {
  constructor(message: string) {
    super(message);
    this.name = 'SwimmableValidationError';
  }
}

/**
 * Exception raised for authentication-related errors (401, 403)  
 */
export class SwimmableAuthenticationError extends SwimmableAPIError {
  constructor(
    message: string,
    status: number,
    code?: string,
    endpoint?: string
  ) {
    super(message, status, code, endpoint);
    this.name = 'SwimmableAuthenticationError';
  }
}

/**
 * Exception raised when rate limits are exceeded (429)
 */
export class SwimmableRateLimitError extends SwimmableAPIError {
  public retryAfter?: number;

  constructor(
    message: string,
    retryAfter?: number,
    endpoint?: string
  ) {
    super(message, 429, 'RATE_LIMIT_EXCEEDED', endpoint);
    this.name = 'SwimmableRateLimitError';
    this.retryAfter = retryAfter;
  }
}